import { PromoOfferBadgeType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { ProfileManager } from '@/shared/lib/profileManager';

interface GetBadgeTypeProps {
    profileManager: ProfileManager;
    isPurchasable: boolean;
}

export const getBadgeType = ({ profileManager, isPurchasable }: GetBadgeTypeProps) =>
    profileManager.hasSubscription.get() && isPurchasable
        ? PromoOfferBadgeType.Amediateka
        : PromoOfferBadgeType.NoBadge;
